import { Param } from "../pages/MainPage"

export class QBPModel {
    name: string
    delta: number
    price: number
    cardinality: number
    price_pempem: number
    price_highlighted: number

    constructor(q: any) {
        this.name = q.name
        this.delta = q.delta
        this.price = q.price
        this.cardinality = q.cardinality
        this.price_pempem = q.price_pempem
        this.price_highlighted = q.price_highlighted
    }

    static build(q: any): QBPModel {
        return new QBPModel(q)
    }
}

export class PriceModel {

    id: number
    pricePerUnit?: number
    millId?: number
    millName?: string
    subdistrict?: string
    village?: string
    coordinates?: number[]
    qbp_prices?: Array<QBPModel>
    program_name?: string

    constructor(p: any) {
        this.id = p.id
        this.pricePerUnit = p.price
        this.millId = p.millId
        this.millName = p.millName
        this.subdistrict = p.subdistrict
        this.village = p.village
        this.coordinates = p.coordinates
        this.qbp_prices = p.qbp_prices?.map((q: any) => QBPModel.build(q))
        this.program_name = p.program_name
    }

    isProgramPrice() {
        return this.program_name === "fcrop-unilever-v01"
    }

    toParam(): Param[] {
        return [
            { key: "id", value: this.id },
            { key: "price", value: this.pricePerUnit },
            { key: "mill_id", value: this.millId },
            { key: "mill_name", value: encodeURIComponent(this.millName ?? "") },
            { key: "subdistrict", value: this.subdistrict },
            { key: "village", value: this.village },
            { key: "qbp", value: encodeURIComponent(JSON.stringify(this.qbp_prices)) },
            { key: "program_name", value: this.program_name },
        ]
    }

    static build(p: any) {
        return new PriceModel(p)
    }

    static buildEmptyPrice() {
        return new PriceModel({ id: -1, pricePerUnit: -1 })
    }

    static buildLocalPrice(p: number) {
        return new PriceModel({ id: 0, pricePerUnit: p })
    }

    static buildFromFeature(p: any, g: any) {
        let qbp: any[] | undefined = [];
        try {
            qbp = typeof p.qbp_prices === 'string' ? JSON.parse(p.qbp_prices) : p.qbp_prices
        } catch (e) {
            qbp = undefined;
        }

        return new PriceModel({
            id: p.id,
            price: p.price_per_unit,
            millId: p.organisation_id,
            millName: p.organisation_name,
            subdistrict: p.location_subdistrict,
            village: p.location_village,
            coordinates: g.coordinates,
            qbp_prices: qbp || [],
            program_name: p.program_name
        });
    }

    static buildFromParam(param: any) {
        let qbp: any[] | undefined = [];
        try {
            qbp = JSON.parse(param.get("qbp"))
        } catch (e) {
            qbp = undefined;
        }
        return new PriceModel({
            id: param.get("id"),
            price: param.get("price"),
            millId: param.get("mill_id"),
            millName: decodeURIComponent(param.get("mill_name") ?? ""),
            subdistrict: param.get("subdistrict"),
            village: param.get("village"),
            qbp_prices: qbp,
            program_name: param.get('program_name')
        });
    }

    location() {
        return `${this.subdistrict}, ${this.village}`
    }
}